import { useMutableRef } from '@carnica/utils/hooks';
import { useEffect } from 'react';
var getNodeParents = function getNodeParents(element) {
  var mutableParents = [];
  var currentNode = element;
  while (currentNode) {
    if (currentNode !== element) {
      mutableParents.push(currentNode);
    }
    currentNode = currentNode.parentNode;
  }
  return mutableParents;
};

/** Запрос репозиции поповера при ресайзе окна и скролле */
export var usePopoverReposition = function usePopoverReposition(_ref) {
  var isActive = _ref.isActive,
    scrollAnchorRef = _ref.scrollAnchorRef,
    onRequestReposition = _ref.onRequestReposition;
  var onRequestRepositionRef = useMutableRef(onRequestReposition);
  useEffect(function () {
    var fn = function fn() {
      return onRequestRepositionRef.current();
    };
    if (isActive) {
      window.addEventListener('resize', fn);
      var allParents = scrollAnchorRef !== null && scrollAnchorRef !== void 0 && scrollAnchorRef.current ? getNodeParents(scrollAnchorRef.current) : [];
      allParents.forEach(function (parentEl) {
        return parentEl.addEventListener('scroll', fn);
      });
      return function () {
        window.removeEventListener('resize', fn);
        allParents.forEach(function (parentEl) {
          return parentEl.removeEventListener('scroll', fn);
        });
      };
    }
    return undefined;
  }, [scrollAnchorRef]);
};